import { useRef, useState } from 'react';
import { AvatarEvent, AvatarState, useAriaAvatar } from '@wix/aria-ai-avatar';
import { TIMING } from '../config/animation';

export const useAvatarSetup = (options?: {
  mode?: 'light' | 'dark';
  variant?: '2d' | '3d';
}) => {
  const [avatarHidden, setAvatarHidden] = useState(true);
  const [isBored, setIsBored] = useState(false);
  const AriaAvatar = useAriaAvatar(options);
  const boredomTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const resetBoredomTimeout = () => {
    setIsBored(false);
    if (AriaAvatar.getState() === AvatarState.SLEEPING) {
      AriaAvatar.setState(AvatarState.IDLE);
    }
    if (boredomTimeoutRef.current) {
      clearTimeout(boredomTimeoutRef.current);
    }
    boredomTimeoutRef.current = setTimeout(async () => {
      setIsBored(true);
      await AriaAvatar.setState(AvatarState.SLEEPING);
    }, TIMING.BOREDOM_TIMEOUT);
  };

  const wrappedAriaAvatar = {
    ...AriaAvatar,
    lookAt: (x: number, y: number) => {
      resetBoredomTimeout();
      return AriaAvatar.lookAt(x, y);
    },
    setState: (state: AvatarState) => {
      resetBoredomTimeout();
      return AriaAvatar.setState(state);
    },
    fireEvent: (event: AvatarEvent) => {
      resetBoredomTimeout();
      return AriaAvatar.fireEvent(event);
    },
  };

  return {
    AriaAvatar: wrappedAriaAvatar,
    avatarHidden,
    setAvatarHidden,
    isBored,
  };
};
